<template>
  <div>
    <alert-component
    :is-active="isConfirmRemoveActive"
    :is-working="isConfirmRemoveWorking"
    :alert-object="confirmRemoveObject"
    :alert-data="confirmRemoveData"
    @confirm="confirmRemoveConfirm"
    @cancel="confirmRemoveCancel"/>
    <div ref="wizardContainer" class="is-vspaced">
      <!--pre v-html="uploads"/-->
      <div class="content wizard" ref="wizardSteps" :key="wizardKey">
        <form v-show="wizardFrame === 'start'">
          <div class="column">
            <div class="notification">
              <h5>{{ 'wizard_start_title' | term }}</h5>
              <div v-html="$root.term('wizard_start_text')"/>
            </div>
          </div>
          <div class="column">
            <!-- desktop integrated menu -->
            <div class="is-hidden-touch">
              <div class="buttons is-flex-end">
                <b-button type="is-info" @click="wizardNext" class="is-uppercase">{{ 'start' | term }}</b-button>
              </div>
            </div>
            <!-- mobile floating menu -->
            <div class="is-hidden-desktop navbar is-fixed-bottom">
              <b-button type="is-info" @click="wizardNext" class="is-uppercase">{{ 'start' | term }}</b-button>
            </div>
          </div>
        </form>
        <form v-show="wizardFrame === 'photos'" class="animated fadeIn">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <svg-icon icon="one" class="icon is-large"/>
            </div>
            <div class="column">
              <h2 class="is-marginless">{{ 'photos' | term }}</h2>
              <p>Vehicle Photo's</p>
            </div>
          </div>
          <div class="columns p-1 is-multiline">
            <div class="column is-6-tablet">
              <file-picker
                type="front-left"
                :title="$root.term('wizard_photos_front_left')"
                @file-status="updateFileStatus"></file-picker>
            </div>
            <div class="column is-6-tablet">
              <file-picker
                type="front-right"
                :title="$root.term('wizard_photos_front_right')"
                @file-status="updateFileStatus"></file-picker>
            </div>
            <div class="column is-6-tablet">
              <file-picker
                type="back-left"
                :title="$root.term('wizard_photos_back_left')"
                @file-status="updateFileStatus"></file-picker>
            </div>
            <div class="column is-6-tablet">
              <file-picker
                type="back-right"
                :title="$root.term('wizard_photos_back_right')"
                @file-status="updateFileStatus"></file-picker>
            </div>
          </div>
          <div class="column is-paddingless-right">
            <!-- desktop integrated menu -->
            <div class="is-hidden-touch">
              <div class="buttons is-flex-end">
                <b-button type="is-info" @click="wizardNext" class="is-uppercase" :disabled="!framePhotosComplete" :loading="!framePhotosComplete">{{ 'continue' | term }}</b-button>
              </div>
            </div>
            <!-- mobile floating menu -->
            <div class="is-hidden-desktop navbar column is-fixed-bottom has-text-center">
              <div class="buttons is-flex-center">
                <b-button type="is-info" @click="wizardNext" class="is-uppercase" :disabled="!framePhotosComplete" :loading="!framePhotosComplete">{{ 'continue' | term }}</b-button>
              </div>
            </div>
          </div>
        </form>
        <form v-show="wizardFrame === 'damages'" class="animated fadeIn">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <svg-icon icon="two" class="icon is-large"/>
            </div>
            <div class="column">
              <h2 class="is-marginless">{{ 'damages' | term }}</h2>
            </div>
          </div>
          <div class="columns is-vcentered">
            <div class="column">
              <file-picker-multiple
                type="damages"
                title=""
                accept="image/*,video/*"
                @file-multiple-status="updateFileMultipleStatus"></file-picker-multiple>
            </div>
            <div class="column">
              <p><small>Capture or upload the photos of your vehicle following the position indicated on each graphic</small></p>
            </div>
          </div>
          <div v-if="uploads.damages && uploads.damages.files" class="columns is-multiline is-vcentered">
            <div class="column is-6-tablet is-4-desktop animated fadeIn" v-for="(item, index) in uploads.damages.files" :key="index">
              <file-upload
                :file="item"
                @ask-remove="askRemoveFile" />
            </div>
          </div>
          <div class="column is-paddingless-right">
            <!-- desktop integrated menu -->
            <div class="is-hidden-touch">
              <div class="buttons is-flex-end">
                <b-button v-if="this.wizardSkipTechical" type="is-info" @click="submitPhotos" class="is-uppercase" :disabled="!frameDamagesComplete" :loading="!frameDamagesComplete">{{ 'Submit your photos' | term }}</b-button>
                <b-button v-else type="is-info" @click="wizardNext" class="is-uppercase" :disabled="!frameDamagesComplete" :loading="!frameDamagesComplete">{{ 'continue' | term }}</b-button>
              </div>
            </div>
            <!-- mobile floating menu -->
            <div class="is-hidden-desktop navbar column is-fixed-bottom has-text-center">
              <div class="buttons is-flex-center">
                <b-button v-if="this.wizardSkipTechical" type="is-info" @click="submitPhotos" class="is-uppercase" :disabled="!frameDamagesComplete" :loading="!frameDamagesComplete">{{ 'Submit your photos' | term }}</b-button>
                <b-button v-else type="is-info" @click="wizardNext" class="is-uppercase" :disabled="!frameDamagesComplete" :loading="!frameDamagesComplete">{{ 'continue' | term }}</b-button>
              </div>
            </div>
          </div>
        </form>
        <form v-show="wizardFrame === 'technical'" class="animated fadeIn">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <svg-icon icon="three" class="icon is-large"/>
            </div>
            <div class="column">
              <h2 class="is-marginless">{{ 'technical' | term }}</h2>
              <div v-html="$root.term('wizard_technical_text')"/>
            </div>
          </div>
          <div class="columns p-1 is-multiline">
            <div class="column is-6-tablet" v-show="parseInt(mycase.vars.ask_mileage)">
              <file-picker
                type="car-mileage"
                title="Car Mileage"
                @file-status="updateFileStatus"></file-picker>
            </div>
            <div class="column is-6-tablet" v-show="parseInt(mycase.vars.ask_vin)">
              <file-picker
                type="vin-number"
                title="Vin Number"
                @file-status="updateFileStatus"></file-picker>
            </div>
          </div>
          <div class="column is-paddingless-right">
            <!-- desktop integrated menu -->
            <div class="is-hidden-touch">
              <div class="buttons is-flex-end">
                <b-button type="is-info" @click="submitPhotos" class="is-uppercase" :disabled="!frameTechicalComplete" :loading="!frameTechicalComplete">{{ 'Submit your photos' | term }}</b-button>
              </div>
            </div>
            <!-- mobile floating menu -->
            <div class="is-hidden-desktop navbar column is-fixed-bottom is-flex-center has-text-center">
              <div class="buttons is-flex-center">
                <b-button type="is-info" @click="submitPhotos" class="is-uppercase" :disabled="!frameTechicalComplete" :loading="!frameTechicalComplete">{{ 'Submit your photos' | term }}</b-button>
              </div>
            </div>
          </div>
        </form>
        <form v-show="wizardFrame === 'success'" class="animated fadeIn">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <svg-icon icon="success" class="icon is-large"/>
            </div>
            <div class="column">
              <h2 class="is-marginless">Thank you!</h2>
              <p><small>We have receive your photos. Will contact you soon</small></p>
            </div>
          </div>
        </form>
        <form v-show="wizardFrame === 'fail'" class="animated fadeIn">
          <div class="columns is-mobile">
            <div class="column is-narrow">
              <svg-icon icon="fail" class="icon is-large"/>
            </div>
            <div class="column">
              <h2 class="is-marginless">Oops</h2>
              <p><small>Error message with links</small></p>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'
import SvgIcon from '@/components/SvgIcon'
import FileUpload from '@/components/FileUpload'
import FilePicker from '@/components/FilePicker'
import FilePickerMultiple from '@/components/FilePickerMultiple'
import AlertComponent from '@/components/AlertComponent'
export default {
  name: 'wizard',
  components: {
    SvgIcon,
    FileUpload,
    FilePicker,
    FilePickerMultiple,
    AlertComponent
  },
  computed: {
    wizardSkipTechical () {
      return !parseInt(this.mycase.vars.ask_mileage) &&
        !parseInt(this.mycase.vars.ask_vin)
    },
    frameDamagesComplete () {
      return this.checkUploadMulti(['damages'])
    },
    frameTechicalComplete () {
      let check = []
      if (parseInt(this.mycase.vars.ask_mileage)) {
        check.push('car-mileage')
      }
      if (parseInt(this.mycase.vars.ask_vin)) {
        check.push('vin-number')
      }
      return this.checkUpload(check)
    },
    framePhotosComplete () {
      return this.checkUpload([
        'front-right',
        'front-left',
        'back-right',
        'back-left'
      ])
    },
    frameStartComplete () {
      return true
    },
    ...mapState([
      'mycase',
      'uploads'
    ])
  },
  data () {
    return {
      data: {},
      wizardKey: 0,
      wizardStep: 0,
      mustDoFirst: localStorage.getItem('mustDoFirst') || 1,
      wizardFrame: 'start',
      wizardFrames: [
        'start',
        'photos',
        'damages',
        'technical',
        'success',
        'fail'
      ],
      confirmRemoveData: {},
      confirmRemoveObject: {
        title: '',
        text: '',
        extra: ''
      },
      caseResult: '',
      insufficientData: false,
      isConfirmRemoveActive: false,
      isConfirmRemoveWorking: false
    }
  },
  created () {
    if (!Object.keys(this.mycase).length) {
      this.$router.push('/abort')
    }
    if (this.$route.params.step) {
      this.wizardStep = parseInt(this.$route.params.step)
      this.wizardFrame = this.wizardFrames[this.wizardStep]
    }
    this.wizardCheck()
  },
  watch: {
    $route (to, from) {
      this.wizardStep = parseInt(this.$route.params.step)
      this.wizardFrame = this.wizardFrames[this.wizardStep]
      this.wizardCheck()
    }
  },
  methods: {
    checkUpload (ids) {
      var found = true
      for (const id of ids) {
        if (!this.uploads[id] || !this.uploads[id].path) {
          found = false
          break
        }
      }
      return found
    },
    checkUploadMulti (ids) {
      var found = true
      for (const id of ids) {
        if (!this.uploads[id] || !this.uploads[id].files) {
          found = false
          break
        }
      }
      return found
    },
    submitPhotos (data) {
      this.$store.dispatch('showLoader', { message: this.$root.term('saving_case') })
      axios.post('/case_end.php', this.mycase.vars).then(res => {
        setTimeout(() => {
          if (res.data.status === 'success') {
            if (this.wizardSkipTechical) {
              this.wizardTo(4)
            } else {
              this.wizardNext()
            }
          } else {
            this.wizardTo(5)
          }
          setTimeout(() => {
            this.$store.dispatch('hideLoader')
          }, 1000)
        }, 1000)
      })
    },
    updateFileStatus (data) {
      this.$store.dispatch('upload', data)
    },
    updateFileMultipleStatus (data) {
      this.$store.dispatch('uploadMulti', data)
    },
    askRemoveFile (data) {
      this.confirmRemoveData = data
      this.confirmRemoveObject = {
        title: 'remove_confirm_title',
        text: 'remove_confirm_text',
        extra: data.orig_name
      }
      this.isConfirmRemoveActive = true
    },
    confirmRemoveConfirm (data) {
      this.isConfirmRemoveWorking = true
      axios.post('/remove', data).then(res => {
        this.$store.dispatch('remove', data)
        this.isConfirmRemoveActive = false
        this.isConfirmRemoveWorking = false
        this.$buefy.toast.open({
          message: this.$root.term('file_delete_success'),
          type: 'is-success'
        })
      })
    },
    confirmRemoveCancel () {
      this.isConfirmRemoveActive = false
    },
    wizardNext () {
      this.wizardTo(parseInt(this.$route.params.step) + 1)
    },
    wizardPrev () {
      this.wizardTo(parseInt(this.$route.params.step) - 1)
    },
    wizardTo (to) {
      this.$route.params.step = to
      this.$router.push(`/wizard/${this.$route.params.step}`)
    },
    wizardCheck () {
      /* case is uncomplete and trying ff manually */
      this.mustDoFirst = 0
      for (const i in this.wizardFrames) {
        const j = parseInt(i)
        if (!this[`frame${this.$root.camelize(this.wizardFrames[j])}Complete`]) {
          this.mustDoFirst = j + 1
          break
        }
      }
      if (this.mustDoFirst && this.wizardStep < 4) {
        if (this.wizardStep >= this.mustDoFirst) {
          this.$store.state.loaded = false
          this.$store.state.loading.buttons = [{
            label: this.$root.term('continue'),
            click: () => {
              this.$router.push(`/wizard/${this.mustDoFirst - 1}`)
            }
          }]
          this.$store.state.loading.spin = false
          this.$store.state.loading.message = [this.$root.term('wizard_mustdofirst_text'), this.$root.term(this.wizardFrames[this.mustDoFirst - 1])].join(` `)
        } else {
          this.$store.state.loaded = true
        }
        localStorage.setItem('mustDoFirst', this.mustDoFirst)
      } else {
        /* case is complete */
        if (this.wizardFrame === 'success') {
          localStorage.removeItem('mycase')
          localStorage.removeItem('uploads')
          localStorage.setItem('mustDoFirst', 0)
          this.$store.commit('case_success', Object.assign({}, this.$store.state.mycase, {
            vars: {
              client: this.$store.state.mycase.client,
              terms: this.$store.state.mycase.terms
            },
            status: 'completed',
            modified: moment().format()
          }))
        }
      }
    }
  }
}
</script>
